/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import OfficeVisitDataContent from "components/content/OfficeVisitDataConent";
import DefaultDashboardLayout from "layouts/dashboard/DefaultDashboardLayout";
import { FC } from "react";

/**
 * Office visit management and kanban board page.
 * 
 * Features:
 * - Kanban-style board for managing patient office visits
 * - Drag-and-drop workflow management (check-in, vitals, exam, checkout)
 * - Real-time visit status tracking
 * - Quick access to patient charts and visit documentation
 * - Integration with appointments, vitals, and billing
 * - Provider assignment and scheduling
 * 
 * @returns Office visit management page component
 */
const OfficeVisitPage: FC = () => {
  return (
    <DefaultDashboardLayout>
      <OfficeVisitDataContent />
    </DefaultDashboardLayout>
  );
};

export default OfficeVisitPage;

